import ApiClient from 'src/api/client';
import { LandingRoutes } from 'src/api/routes';

import { fileUploadHeaders } from './utils';

export class LandingApi {
  static contactUs(data) {
    return ApiClient.post(LandingRoutes.CONTACT_FORM, data);
  }
  static signUpForVoucher(data) {
    return ApiClient.post(LandingRoutes.VOUCHER_FORM, data, {
      headers: fileUploadHeaders
    });
  }
}
